import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);
const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'Period',
    data: 'PERIOD_COVERED'
  },
  {
    title: 'Total Scan',
    data: 'TOTAL_SCAN'
  },
  {
    title: 'Total Redeem',
    data: 'TOTAL_REDEEM'
  },
  {
    title: 'Total Balance',
    data: 'TOTAL_BALANCE'
  },
  {
    title: 'Total Reward',
    data: 'TOTAL_REWARD'
  },
  {
    title: 'Campaign Name',
    data: 'CAMPAIGN_NAME'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Username',
    data: 'USERNAME'
  },
  {
    title: 'Country',
    data: 'COUNTRY_CODE'
  },
  {
    title: 'Company Name',
    data: 'COMPANY_NAME'
  },
  {
    title: 'Company Address',
    data: 'COMPANY_ADDR'
  },
  {
    title: 'City / Province',
    data: 'COMPANY_BRANCH'
  },
  {
    title: 'Company Tax Code',
    data: 'COMPANY_NUMBER'
  },
  {
    title: 'Sup Tax Code',
    data: 'SUP_TAX_CODE'
  },
  {
    title: 'Phone Number',
    data: 'TEL'
  },
  {
    title: 'Sup. Name',
    data: 'SUP_NAME'
  },
  {
    title: 'Company Case (1, 2 or 3)',
    data: 'COMPANY_TYPE'
  }
];

function reloadTableData(names) {
  const table = $(`#${id}`).DataTable();
  table.clear();
  table.rows.add(names);
  table.draw();
}

function updateTable(names) {
  const table = $(`#${id}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = names.find((nameData) => {
      return nameData.name === oldNameData.name;
    });
    if (oldNameData.nickname !== newNameData.nickname) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  if (dataChanged) {
    table.draw();
  }
}

class Table4 extends Component {
  componentDidMount() {
    $(`#${id}`).DataTable({
      dom: 'Bfrtip',
      data: this.props.names,
      columns,
      searching: true,
      paging: true,
      ordering: true,
      scrollX: true,
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_reward_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_reward_excel_${Date.now()}`
        }
      ]
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names);
    } else {
      updateTable(nextProps.names);
    }
    return false;
  }

  render() {
    return (
      <div>
        <table ref="main" className="display" id={id} />
      </div>
    );
  }
}
export default Table4;
